import React from "react";
import { TouchBackend } from "react-dnd-touch-backend";
import { HTML5Backend } from "react-dnd-html5-backend";
import {
  DndProvider as ReactDndProvider,
  MouseTransition,
  TouchTransition,
} from "react-dnd-multi-backend";

const HTML5ToTouch = {
  backends: [
    {
      id: "html5",
      backend: HTML5Backend,
      transition: MouseTransition,
    },
    {
      id: "touch",
      backend: TouchBackend,
      preview: true,
      options: {
        delayTouchStart: 350,
      },
      transition: TouchTransition,
      skipDispatchOnTransition: true,
    },
  ],
};

export const DndProvider: React.FunctionComponent<
  React.PropsWithChildren<unknown>
> = ({ children }) => {
  return <ReactDndProvider options={HTML5ToTouch}>{children}</ReactDndProvider>;
};
